module.exports = __webpack_public_path__ + "media/images/lig/icon-equal-7615ee7c2f39bdc84dbfbe5e6d150b65.svg";